import React from 'react';
import { Helmet } from 'react-helmet';

const TikTokPixel = () => {
	const isLocal = typeof window !== 'undefined' && window.location.hostname === 'localhost';
	const pixelId = 'CFIKQNRC77UCCRP9826G';
	const testCode = isLocal ? '&test_event_code=TEST123456' : '';

	const pixelScript = `
    !function(w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = w[t] = w[t] || [];
      ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie"];
      ttq.setAndDefer = function(t, e) {
        t[e] = function() {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
        }
      };
      for (var i = 0; i < ttq.methods.length; i++) {
        ttq.setAndDefer(ttq, ttq.methods[i]);
      }
      ttq.load = function(e, n) {
        var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
        ttq._i = ttq._i || {};
        ttq._i[e] = [];
        ttq._i[e]._u = i;
        ttq._t = ttq._t || {};
        ttq._t[e] = +new Date;
        ttq._o = ttq._o || {};
        ttq._o[e] = n || {};
        var o = document.createElement("script");
        o.type = "text/javascript";
        o.async = true;
        o.src = i + "?sdkid=" + e + "&lib=" + t + "${testCode}";
        var a = document.getElementsByTagName("script")[0];
        a.parentNode.insertBefore(o, a);
      };
      ttq.load('${pixelId}');
      ttq.page();
    }(window, document, 'ttq');
  `.replace('${testCode}', testCode); // inject value correctly

	return (
		<Helmet>
			<script type="text/javascript">{pixelScript}</script>
			<noscript>
				{`<img height="1" width="1" style="display:none" src="https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=${pixelId}${testCode}" />`}
			</noscript>
		</Helmet>
	);
};

export default TikTokPixel;
